function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.064,1.459C22.197,0.422 20.597,0 17.542,0L6.454,0C3.33,0 1.703,0.45 0.839,1.553C-0.002,2.629 -0.002,4.215 -0.002,6.409L-0.002,10.591C-0.002,14.841 0.998,17 6.454,17L17.542,17C20.192,17 21.66,16.627 22.609,15.712C23.582,14.774 24,13.242 24,10.591L24,6.409C24,4.095 23.933,2.5 23.064,1.459ZM15.406,9.077L10.371,11.726C10.259,11.785 10.137,11.814 10.012,11.814C9.873,11.814 9.735,11.777 9.613,11.702C9.379,11.561 9.238,11.308 9.238,11.035L9.238,5.755C9.238,5.483 9.379,5.23 9.61,5.089C9.842,4.948 10.129,4.938 10.371,5.064L15.404,7.695C15.662,7.829 15.821,8.095 15.821,8.385C15.821,8.676 15.662,8.943 15.406,9.077Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.90c0ca88a4b945760fe702ac8e8b7858.svg";
export { ForwardRef as ReactComponent };